import { CitationCommonStyle } from './citationCommon';

export const CampaignInProgressStyles = {
  headerCard: {
    marginTop: '24px'
  },
  headerContentBox: {
    paddingX: '24px'
  },
  headerDetailsBox: {
    paddingX: '24px',
    marginTop: '24px'
  },
  heading: {
    ...CitationCommonStyle.typography.headingLarge
  },
  body: {
    ...CitationCommonStyle.typography.bodyMedium,
    color: 'var(--color-text-secondary)'
  },
  labelKey: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    marginBottom: '8px'
  },
  campaignCard: {
    marginTop: '16px'
  },
  stepperWrapper: {
    //paddingX: '24px',
    marginY: '24px'
  },
  stepper: {
    '& .MuiStepLabel-label': {
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: 'var(--font-size-14)',
      color: 'var(--color-primary)'
    },
    '& .MuiStepLabel-label.Mui-active': {
      color: 'var(--color-primary)'
    },
    '& .MuiStep-root.Mui-disabled .MuiStepLabel-label': {
      color: 'var(--color-text-placeholder)'
    }
  },
  stepIconBase: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
  },
  stepLabelTextBase: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  stepSubLabel: {
    marginTop: '4px',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-secondary)'
  },
  actionsContainer: {
    paddingX: '24px',
    paddingTop: '8px',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '12px',
    paddingBottom: '4px'
  },
  primaryButton: {
    padding: '8px 18px'
  },
  secondaryButton: {
    padding: '8px 18px'
  },
  completedIcon: {
    height: '24px',
    width: '24px'
  },
  completedStepIcon: {
    height: '32px',
    width: '32px'
  }
};


